import { Newsletter } from "../components/site/Newsletter";
import { Overline } from "../components/site/primitives";

export default function Signup() {
  return (
    <div data-testid="signup-page" className="relative flex min-h-screen flex-col justify-center overflow-x-clip bg-ivory">
      <div className="grain-overlay" />
      <main className="relative">
        <div className="mx-auto max-w-[760px] px-6 pt-16 text-center md:px-10">
          <Overline>Creating Wealth Through Community</Overline>
        </div>
        <Newsletter />
        <p className="pb-16 text-center font-sans text-sm font-light text-stonegray">
          Want the full story?{" "}
          <a href="/creatingwealth" data-testid="signup-landing-link" className="text-terracotta underline underline-offset-4 hover:text-ink">
            Explore Creating Wealth Through Community
          </a>
        </p>
      </main>
    </div>
  );
}
